import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Box, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import type { CommunicationLog } from '../../data/types';
import { dateTime } from '../../lib/format';
import { templateFor } from '../../manager/communications/templates';
import { useInvestorScope } from '../../store/selectors';
import { Card, InvestorTitle } from '../common';

export default function MessagesPage() {
  const scope = useInvestorScope();
  const [open, setOpen] = useState<CommunicationLog | null>(null);
  const firstName = scope.login.name.split(' ')[0];
  const fundName = (log: CommunicationLog) =>
    scope.funds.find((fund) => fund.id === log.fundId)?.name ?? '';
  const body = (log: CommunicationLog) =>
    templateFor(log.template)
      .body.replace(/\{\{firstName\}\}/g, firstName)
      .replace(/\{\{fund\}\}/g, fundName(log) || 'your fund')
      .replace(/\{\{message\}\}/g, 'Please see the latest update from the team in the app.')
      .replace(/\{\{[a-zA-Z]+\}\}/g, '…');
  return (
    <>
      <InvestorTitle
        title="Messages"
        subtitle="Notices and updates from the registry, newest first."
      />
      <Card sx={{ p: 0 }}>
        {scope.communications.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
            No messages yet.
          </Typography>
        )}
        {scope.communications.map((log, index) => (
          <Stack
            key={log.id}
            direction="row"
            spacing={1.5}
            alignItems="center"
            onClick={() => setOpen(log)}
            sx={{
              px: 2,
              py: 1.5,
              borderTop: index ? '1px solid' : 'none',
              borderColor: 'divider',
              cursor: 'pointer',
              '&:hover': { bgcolor: 'background.default' },
            }}
          >
            <MailOutlineIcon color="secondary" />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {log.subject}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {templateFor(log.template).name}
              </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
              {dateTime(log.at)}
            </Typography>
          </Stack>
        ))}
      </Card>
      <Dialog open={Boolean(open)} onClose={() => setOpen(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>{open?.subject}</DialogTitle>
        <DialogContent>
          <Typography variant="caption" color="text.secondary">
            {open ? dateTime(open.at) : ''}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mt: 1.5 }}>
            {open ? body(open) : ''}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
}
